const fetchUser = { data: [], loading: true };
export const GetFetchUserData = (state = fetchUser, action) => {
  switch (action.type) {
    case "get_userData":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
